import whyChooseNirva from '../../../assets/images/access-client-portal.webp';
import { CONSULTATION_COPY } from '../../../constants/consultation';
import { openSimplePracticeClientPortal } from '../../../utils/simplePractice';

export const HERO = {
  overHeading: CONSULTATION_COPY.bookYour,
  heading: 'Beautiful Thinking. Peaceful Living.',
  subHeading: 'Begin with a conversation.',
  subtext:
    CONSULTATION_COPY.intro,
  containedButtonText: CONSULTATION_COPY.book,
};

export const EXPECTATIONS = {
  title: 'What You Can Expect',
  texts: [
    'While experiences vary from person to person, many clients describe hypnotherapy as calming, clarifying, and practically helpful in everyday life.',
  ],
  buttonText: 'Learn More About Our Services',
  list: {
    items: [
      '<b>A caring, confidential conversation</b> focused on your needs and intentions',
      '<b>Clarity on how hypnotherapy works</b> and what a first session looks like',
      '<b>Personalized guidance</b> tailored to your goals—such as stress reduction, confidence building, habit change, purpose clarification, and more.',
      '<b>Simple next steps</b> if you choose to proceed',
    ],
  },
  gaps: {
    beforeCTAButton: 50,
    btwnTitleAndText: 14,
    betweenTexts: 30,
  },
  wrapperMaxWidth: 1100,
  listItemTextMaxWidth: 462,
  listGap: 14,
};

export const HOW_WE_WORK = {
  title: 'How We Work',
  subtitle: 'At a glance (full journey):',
  description:
    'Book a 30-Minute Free Consultation → Complete Client Portal Forms → Book Your Session → Session(s) → Follow-Up',
  listTitle: 'Step-by-step:',
  responseTimeText:
    '<b>Response time:</b> We reply <b>within 24 hours on weekdays</b> and <b>by the next business day</b> for weekend requests.',
  button: { text: CONSULTATION_COPY.book },
  cards: [
    {
      title: CONSULTATION_COPY.bookA,
      description:
        'Choose a time for a brief, confidential conversation so we can learn more about your goals and help guide the next best step.',
      number: '1',
    },
    {
      title: 'Complete Client Portal Forms',
      description:
        'After scheduling, clients will receive any required forms through the secure client portal before moving forward.',
      number: '2',
    },
    {
      title: 'Book Your Session',
      description: 'When it feels like a good fit, the client may select their first appointment time.',
      number: '3',
    },
    {
      title: 'Session(s)',
      description:
        'Clients meet with their practitioner in a supportive, private setting designed for meaningful subconscious work.',
      number: '4',
    },
    {
      title: 'Follow-Up',
      description:
        'Clients may continue their process with additional sessions or next steps as recommended by their practitioner.',
      number: '5',
    },
  ],
};

export const WHY_CHOOSE = {
  title: 'Why People Choose Nirva',
  image: { src: whyChooseNirva, alt: 'Calm woman with landscape silhouette' },
  list: [
    '<b>Certified practitioners</b> trained through the <b>Institute of Interpersonal Hypnotherapy (IIH)</b>, grounded in compassion and ethical practice',
    '<b>Professional standards & ethics</b> you can trust',
    '<b>A steady, respectful approach—</b>you set the pace, we support the process',
    '<b>Free resources</b> to support you between sessions',
  ],
};

export const COMMON_QUESTIONS = {
  title: 'Is This Right for Me?\n<span>(Common Questions)</span>',
  questions: [
    {
      q: 'Is the consultation truly free?',
      a: 'Yes. It`s a complimentary call designed to help you explore whether Nirva is a good fit. During the consultation, your practitioner will lovingly assess your needs to determine if they can help. If the practitioner feels they are not the right fit for you, they will connect you with someone in our network who may be better suited to your goals or preferences.',
    },
    {
      q: 'How long is it?',
      a: CONSULTATION_COPY.durationOnline,
    },
    {
      q: 'Do I need to prepare?',
      a: 'No special preparation is needed. During your initial inquiry, you`ll provide details about your preferred practitioner (gender, age range, time zone, spiritual inclinations) and the issue you wish to work on. This helps us match you with the best practitioner for your needs.',
    },
    {
      q: 'What happens after?',
      a: 'If you and your practitioner are a good fit, you can schedule your first session—often within a few days. Early sessions typically include intake, goal setting, and hypnotic programming. Session rates vary, as each practitioner sets their own fee. You can continue working with your practitioner for as long as you’d like—many clients find their primary concern improves within 2 to 4 sessions.',
    },
  ],
  buttonText: 'Explore Our Services',
};

export const ALREADY_CLIENT = {
  title: 'Already a Client?',
  text: 'Access Nirva’s secure <b>SimplePractice Client Portal</b> to complete intake forms, review and sign documents, manage appointments, send secure messages, and join your telehealth sessions.',
  buttonText: 'Access Client Portal',
  onClick: openSimplePracticeClientPortal,
};

export const BOOK_FREE_CONSULTATION = {
  title: 'Ready When You Are',
  text: 'Your path is your own. When you’re ready, we’re here to meet you with presence and care. Reach out anytime using the button below.',
};
